import type { MailContactGroup, MailContactGroupMember } from "@/lib/types/contactGroup";

/** Formate un membre pour une ligne À/Cc. */
export function formatGroupMemberAddress(member: MailContactGroupMember): string {
  const email = member.email.trim();
  const label = member.displayName?.trim();
  if (label && label.toLowerCase() !== email.toLowerCase()) {
    return `${label} <${email}>`;
  }
  return email;
}

/** Déplie un groupe en adresses (dédupliquées), prêt pour le champ destinataires. */
export function expandContactGroupToAddressField(group: MailContactGroup): string {
  const seen = new Set<string>();
  const parts: string[] = [];
  for (const member of group.members) {
    const email = member.email.trim().toLowerCase();
    if (!email || seen.has(email)) continue;
    seen.add(email);
    parts.push(formatGroupMemberAddress(member));
  }
  return parts.join(", ");
}
